<template>
  <div id="friendsList">
    <div class="dropdown" v-bind:class="{ active: searchActive }">
      <div class="searchInput">
        <input
          type="search"
          class="dropdown-input"
          v-model="searchTerm"
          hide-no-data
          :items="suggestionList"
          @focus="loadSuggestions"
          @keyup="loadSuggestions"
          placeholder="Search"
        />
        <v-btn icon @click="resetSelection" class="clearBtn"><v-icon>mdi-close</v-icon></v-btn>
      </div>
      <div class="dropdown-list">
        <div
          v-for="item in suggestionList"
          :key="item.id"
          class="dropdown-item"
        >
          <span class="suggestion">{{ item.name }}</span>
          <v-btn color="primary" v-if="!item.status" @click="addFriendById(item)">Add</v-btn>
          <v-btn color="primary" disabled v-if="item.status == 'Request'">Send</v-btn>
        </div>
      </div>
    </div>
    <Friend
      v-for="(friend, i) in sortedFriends"
      :key="i"
      v-bind:friend="friend"
    ></Friend>
    <hr v-if="declineFriends.length > 0" />
    <div v-if="declineFriends.length > 0">
      <h5>Subscribers:</h5>
      <Friend
        v-for="(friend, i) in declineFriends"
        :key="i"
        v-bind:friend="friend"
      ></Friend>
    </div>
  </div>
</template>

<script>
import Friend from "./Friend";
import api from "../api";

export default {
  name: "friendsList",
  data() {
    return {
      searchActive: false,
      searchTerm: "",
      suggestionList: [],
    };
  },
  computed: {
    sortedFriends: function () {
      let sorted = [];
      let friends = this.$store.state.data.friends.filter((friend) => {
        return friend.status == "Request" || friend.status == "Success";
      });
      if (this.searchTerm.length > 0) {
        friends.forEach((friend) => {
          const name = friend.name.toLowerCase();
          if (name.indexOf(this.searchTerm.toLowerCase()) > -1) {
            sorted.push(friend);
          }
        });
      } else {
        return friends;
      }
      return sorted;
    },
    declineFriends: function () {
      let sorted = [];
      let friends = this.$store.state.data.friends.filter((friend) => {
        return friend.status == "Decline";
      });
      if (this.searchTerm.length > 0) {
        friends.forEach((friend) => {
          const name = friend.name.toLowerCase();
          if (name.indexOf(this.searchTerm.toLowerCase()) > -1) {
            sorted.push(friend);
          }
        });
      } else {
        return friends;
      }
      return sorted;
    },
  },
  components: {
    Friend: Friend,
  },
  methods: {
    loadSuggestions() {
      this.searchActive = true;
      var me = this;
      if (this.searchTerm.length > 0) {
        api.searchFriends(this.searchTerm, me, function (success, response) {
          if (success) {
            me.suggestionList = JSON.parse(JSON.stringify(response));
          } else {
            me.suggestionList = [];
          }
        });
      } else {
        me.suggestionList = [];
      }
    },
    addFriendById(item) {
      api.addToFriend(item.id, this, function(success) {
        if (success) {
          item.status = 'Request'
        }
      });
    },
    resetSelection() {
      this.searchTerm = "";
      this.suggestionList = [];
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#friendsList {
  margin: 0 auto;
  border-radius: 15px;
  .search {
    display: flex;
    align-items: center;
    padding: 0.25rem 1rem;
    margin-bottom: 15px;
    border-radius: 999px;
    transition: 0.3s all;
    border: 0px solid #aaa;
    color: #333;
    outline: none;
    input[type="text"] {
      flex-grow: 1;
      padding-left: 0.5rem;
      color: inherit;
      font-family: inherit;
      font-size: 1.25rem;
      background: transparent;
      border: none;
      outline: none;
    }
  }
}
.dropdown {
  position: relative;
  width: 100%;
  z-index: 1;
  max-width: 400px;
  margin: 0 auto;
}
.dropdown-input,
.dropdown-selected {
  width: 100%;
  padding: 10px 16px;
  border: 1px solid transparent;
  background: #edf2f7;
  line-height: 1.5em;
  outline: none;
  border-radius: 8px;
}
.dropdown-input:focus,
.dropdown-selected:hover {
  background: #fff;
  border-color: #e2e8f0;
}
.dropdown-input::placeholder {
  opacity: 0.7;
}
.dropdown-selected {
  font-weight: bold;
  cursor: pointer;
}
.dropdown-list {
  position: absolute;
  width: 100%;
  max-height: 500px;
  margin-top: 4px;
  overflow-y: auto;
  background: #ffffff;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
}
.dropdown-item {
  display: flex;
  width: 100%;
  padding: 11px 16px;
}
.dropdown-item:hover {
  background: #edf2f7;
}
.dropdown-item-flag {
  max-width: 24px;
  max-height: 18px;
  margin: auto 12px auto 0px;
}
.suggestion {
  flex-grow: 1;
}
.primary {
  color: rgb(0, 0, 155) !important;
}

.clearBtn {
  position: absolute;
  top: 0;
  right: 0px;
  transform: translateY(5px);
}
</style>